import table from './table'

const activities =
{
    ...table,
    helmet :
    {
        title : 'Activités' ,
        metas : []
    },
    empty  : 'Aucune activité trouvée',
    title  : 'Activités'
};

export default activities ;
